import React, { useMemo } from "react";
import "../../Styles/styles-StatusTracker.css";
import { useSelector } from "react-redux";
import {
    Avatar,
    Tooltip,
} from "antd";
import { getTextColorBasedOnBg } from '../../Utils/color_utils';
import { createStatusAvatarList } from './statusTrackerUtil';

const MAX_AVATAR_COUNT = 3;

export const PlayerHeader = ({ uniqueKeys }) => {
    const {
        info: { team_logo },
    } = useSelector(({ team }) => team);
    const {
        trackerData,
        statuses
    } = useSelector(({ statusTracker }) => statusTracker);

    const trackerDS = useMemo(() => {
        const uKeysSet = new Set(uniqueKeys);
        return Object.fromEntries(Object.entries(trackerData).filter(([key]) => uKeysSet.has(key)));
    }, [uniqueKeys, trackerData]);

    const statusCountList = useMemo(() => {
        const list = [];
        createStatusAvatarList(trackerDS, statuses, (computed) => list.push(...computed));
        return list;
    }, [trackerDS, statuses]);

    const visibleStatusAvatars = statusCountList.slice(0, MAX_AVATAR_COUNT);
    const hiddenStatusAvatars = statusCountList.slice(MAX_AVATAR_COUNT);

    const getHiddenStatusAvatarTooltip = () => {
        return hiddenStatusAvatars.map(([hiddenStatus, count]) => {
            const statusColor = hiddenStatus.color;
            return (
                <div>
                    <span
                        style={{
                            width: 10,
                            height: 10,
                            backgroundColor: statusColor
                        }}
                    >
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <span>
                        {` ${hiddenStatus.name}: ${count}`}
                    </span>
                </div>
            )
        })
    }


    return (
        <>
            <div
                className="tracker-header-card"
                style={
                    statusCountList.length > 0
                    ? {justifyContent: 'space-between'}
                    : {justifyContent: 'flex-start'}
                }
            >
                <div className="tracker-header-card-header-txt">
                    Players
                </div>
                {
                    statusCountList.length > 0 && (
                        <div className="tracker-header-card-status-count">
                            <Avatar.Group
                                size={22}
                                style={{ display: 'flex', flexDirection: 'column'}}
                            >
                                {
                                    visibleStatusAvatars.map(([status, count], idx) => {
                                        const statusColor = status?.color || 'black';
                                        const statusName = status?.name || '';
                                        return (
                                               <Tooltip
                                                key={`visible-header-avatar-${idx}`}
                                                title={`${statusName}: ${count}`}
                                               >
                                                     <Avatar
                                                        style={{
                                                            backgroundColor: statusColor,
                                                            color: getTextColorBasedOnBg(statusColor)
                                                        }}
                                                        key={`header_avatar_${idx}`}
                                                    >
                                                        {count}
                                                    </Avatar>
                                               </Tooltip>
                                        )
                                    })
                                }

                                {
                                    hiddenStatusAvatars.length > 0 && (
                                        <Tooltip title={getHiddenStatusAvatarTooltip}>
                                            <Avatar>+{hiddenStatusAvatars.length}</Avatar>
                                        </Tooltip>
                                    )
                                }
                            </Avatar.Group>
                        </div>
                    )
                }

            </div>
        </>

    );
};
